module.exports = __webpack_public_path__ + "img/san-jose-room.25d82cc3.jpg";